import React from 'react';
import { login, isConfigured } from '../../auth/cognito';
import SignInScreen from './SignInScreen';

// D11-c: shown before anything else loads. The console's data APIs need a
// Cognito session; Amazon Connect's own login is step two, inside.
//
// Sign-in is a redirect to the Cognito Hosted UI (auth/cognito.js), so there
// is no local email/password form here — the design mock's credential fields
// would have to fake an auth path this build does not have.
export default function LoginGate({ error, busy }) {
  const configured = isConfigured();
  const statusText = busy ? 'AUTHENTICATING' : 'CONSOLE ONLINE';

  return (
    <SignInScreen
      statusText={statusText}
      title="Sign in to the console"
      subtitle="Use your knktr work account. Your voice connection is authorised separately in step two."
      error={
        configured
          ? error
          : 'Console sign-in is not configured for this build (VITE_COGNITO_DOMAIN / VITE_COGNITO_CLIENT_ID).'
      }
      step={{
        label: 'STEP 1 OF 2',
        pct: 50,
        body: "After this you'll authorise Amazon Connect for voice. It's a separate login and stays signed in for your shift.",
      }}
      footNote="Calls are recorded · PII auto-redacted"
    >
      <button
        className="sg-submit"
        onClick={login}
        disabled={busy || !configured}
        title="Sign in with your console account"
      >
        {busy && <span className="sg-sweep" aria-hidden="true" />}
        <span>{busy ? 'Signing you in…' : 'Sign in'}</span>
      </button>
    </SignInScreen>
  );
}
